import { PageHeader } from "@/components/common";
import { PriceManager } from "@/components/PriceManager";
import { useAuth } from "@/context/AuthContext";

export default function Prices() {
  const { can } = useAuth();
  return (
    <div>
      <PageHeader sheet="SHEET 07" title="Daftar Harga Voucher" subtitle={can("price:write") ? "Ubah langsung di sel lalu klik simpan pada baris. Setiap perubahan harga tercatat di audit log." : "Hanya pemilik yang dapat mengubah harga."} />
      <PriceManager apiBase="/prices" canEdit={can("price:write")} exportable={can("export:run")} />
    </div>
  );
}
